import { Box, Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { Tooltip } from '../../../components/Tooltip'

interface IGradeBarProps {
  label: string
  tooltip: string
  value: number | null
  maxValue?: number
  animate?: boolean
}

export default function GradeBar({ label, tooltip, value, maxValue = 5, animate = true }: IGradeBarProps) {
  const [width, setWidth] = useState(animate ? 0 : ((value ?? 0) / maxValue) * 100)

  useEffect(() => {
    if (value === null) {
      setWidth(0)
      return
    }

    if (animate) {
      const timeout = setTimeout(() => {
        setWidth((value / maxValue) * 100)
      }, 80)
      return () => clearTimeout(timeout)
    }
    setWidth((value / maxValue) * 100)
  }, [value, maxValue, animate])

  const hasValue = value !== null

  return (
    <Box>
      <Flex justify="space-between" align="center" mb="1">
        <Tooltip label={tooltip} bg="gray.800" color="white" borderRadius="6px">
          <Text fontSize="11px" fontWeight="500" color="gray.600" cursor="help">
            {label}
          </Text>
        </Tooltip>
        <Text
          fontSize="11px"
          fontWeight="600"
          color={hasValue ? 'gray.900' : 'gray.400'}
          sx={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {hasValue ? value!.toFixed(1) : '—'}
        </Text>
      </Flex>
      <Box bg="gray.100" borderRadius="full" h="5px" overflow="hidden">
        <Box
          h="100%"
          w={`${width}%`}
          borderRadius="full"
          bg={hasValue ? 'magenta.500' : 'transparent'}
          sx={{ transition: animate ? 'width .6s cubic-bezier(.22,.61,.36,1)' : 'none' }}
        />
      </Box>
    </Box>
  )
}
